import { OPAQUE_SCRIPT_ERROR_MESSAGES as p, RECENT_SCRIPT_WINDOW_MS as g, SCRIPT_RESOURCE_INITIATOR as E } from "../../constants/scriptErrorDiagnostics.constants.js";
var c = (r) => r.includes("://"), v = ({ message: r = "", stack: i = "", error: e }) => !(!p.includes(r.trim().toLowerCase()) || c(i) || e instanceof Error && c(e.stack ?? "")), S = (r) => {
  if (!r) return null;
  try {
    return new URL(r, window.location.href).origin;
  } catch {
    return null;
  }
}, O = (r) => {
  const i = /* @__PURE__ */ new Map();
  return r.forEach((e) => {
    const n = S(e.getAttribute("src") ?? "");
    if (!n) return;
    const t = i.get(n) ?? {
      origin: n,
      count: 0,
      withCrossOrigin: 0
    };
    t.count += 1, e.hasAttribute("crossorigin") && (t.withCrossOrigin += 1), i.set(n, t);
  }), [...i.values()].sort((e, n) => n.count - e.count);
}, f = (r, i, e) => {
  const n = r.filter((t) => t.initiatorType === E).filter((t) => i - t.responseEnd <= e).map((t) => S(t.name)).filter((t) => !!t);
  return [...new Set(n)];
}, R = (r) => {
  try {
    return [...r.querySelectorAll("script[src]")];
  } catch {
    return [];
  }
}, h = (r) => {
  try {
    return r.getEntriesByType("resource");
  } catch {
    return [];
  }
}, u = 0, w = ({ documentRef: r = document, performanceRef: i = performance, ownOrigin: e = window.location.origin, recentWindowMs: n = g } = {}) => {
  if (u >= 10) return {};
  u += 1;
  const t = R(r), o = O(t), a = i.now();
  return {
    opaqueScriptError: !0,
    scriptOrigins: o,
    foreignScriptOrigins: o.map(({ origin: s }) => s).filter((s) => s !== e),
    recentScriptOrigins: f(h(i), a, n).filter((s) => s !== e),
    scriptCount: t.length,
    crossOriginScriptCount: o.reduce((s, l) => s + l.withCrossOrigin, 0),
    readyState: r.readyState,
    msSinceNavigation: Math.round(a)
  };
};
export {
  w as buildOpaqueErrorContext,
  v as isOpaqueScriptError,
  f as recentScriptOrigins,
  O as summariseScriptOrigins
};

//# sourceMappingURL=scriptErrorDiagnostics.helper.js.map